/* eslint-disable camelcase */

// https://www.evanmiller.org/ab-testing/sample-size.html
// p => base CR. delta -> absolute increase
//    for example
//   "p": 0.2, -> 20% conversion rate
//   "delta": 0.023100000000000002 -> test improved to 22.31% conversion rate
export function minSessionsSampleSize(
  p,
  delta,
  alpha = 0.05,
  power_level = 0.7,
) {
  if (p > 0.5) {
    p = 1.0 - p;
  }
  const t_alpha2 = ppnd(1.0 - alpha / 2);

  const t_beta = ppnd(power_level);

  const sd1 = Math.sqrt(2 * p * (1.0 - p));
  const sd2 = Math.sqrt(p * (1.0 - p) + (p + delta) * (1.0 - p - delta));

  return (
    ((t_alpha2 * sd1 + t_beta * sd2) * (t_alpha2 * sd1 + t_beta * sd2)) /
    (delta * delta)
  );
}

// The Percentage Points of the Normal Distribution
function ppnd(p) {
  const a0 = 2.50662823884;
  const a1 = -18.61500062529;
  const a2 = 41.39119773534;
  const a3 = -25.44106049637;
  const b1 = -8.4735109309;
  const b2 = 23.08336743743;
  const b3 = -21.06224101826;
  const b4 = 3.13082909833;
  const c0 = -2.78718931138;
  const c1 = -2.29796479134;
  const c2 = 4.85014127135;
  const c3 = 2.32121276858;
  const d1 = 3.54388924762;
  const d2 = 1.63706781897;
  let r;
  const split = 0.42;
  let value;

  /*
     0.08 < P < 0.92
     */
  if (Math.abs(p - 0.5) <= split) {
    r = (p - 0.5) * (p - 0.5);

    value =
      ((p - 0.5) * (((a3 * r + a2) * r + a1) * r + a0)) /
      ((((b4 * r + b3) * r + b2) * r + b1) * r + 1.0);
  } else if (p > 0.0 && p < 1.0) {
    /*
     P < 0.08 or P > 0.92,
     R = min ( P, 1-P )
     */
    if (p > 0.5) {
      r = Math.sqrt(-Math.log(1.0 - p));
    } else {
      r = Math.sqrt(-Math.log(p));
    }

    value = (((c3 * r + c2) * r + c1) * r + c0) / ((d2 * r + d1) * r + 1.0);

    if (p < 0.5) {
      value = -value;
    }
  } else {
    /*
     P <= 0.0 or 1.0 <= P
     */
    value = NaN;
  }

  return value;
}
